import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { PermissionsEnum } from '../../../api/api-reference';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-scheduler',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TranslateModule, RouterLink],
  templateUrl: './scheduler.component.html',
  styleUrl: './scheduler.component.scss'
})
export class SchedulerComponent {
  constructor(
    private router: Router,
    public authService: AuthService,
  ) {}
  public PermissionsEnum = PermissionsEnum;

  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }
  navigate(route: string) {
    this.router.navigate([route]);
  }
}
